type HomeIconProps = {
  size?: number
}

export function HomeIcon({ size = 24 }: HomeIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24.0001 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M10.6411 3.3797C11.3976 2.6428 12.6022 2.64313 13.3589 3.3797L13.3599 3.37872L19.8735 9.43634C20.4328 9.95657 20.7505 10.6862 20.7505 11.45V19.2234C20.7504 20.3003 19.8772 21.1736 18.8003 21.1736H14.4009C13.9868 21.1736 13.6511 20.8376 13.6509 20.4236V16.2234C13.6509 15.975 13.4491 15.7734 13.2007 15.7733H10.8003C10.5519 15.7734 10.3501 15.975 10.3501 16.2234V20.4236C10.3499 20.8376 10.0142 21.1736 9.6001 21.1736H5.20068C4.12381 21.1736 3.25063 20.3003 3.25049 19.2234V11.45C3.25051 10.6862 3.56818 9.95657 4.12744 9.43634L10.6411 3.3797ZM12.3188 4.45782C12.1431 4.28209 11.8579 4.28209 11.6821 4.45782C11.6758 4.46414 11.6691 4.47029 11.6626 4.47638L5.14893 10.535C4.89488 10.7714 4.75051 11.103 4.75049 11.45V19.2234C4.75063 19.4719 4.95224 19.6736 5.20068 19.6736H8.8501V16.2234C8.8501 15.1466 9.72343 14.2734 10.8003 14.2733H13.2007C14.2775 14.2734 15.1509 15.1466 15.1509 16.2234V19.6736H18.8003C19.0487 19.6736 19.2504 19.4719 19.2505 19.2234V11.45C19.2505 11.103 19.1061 10.7714 18.8521 10.535L12.3384 4.47638C12.3318 4.47029 12.3252 4.46414 12.3188 4.45782Z" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
    </svg>
  )
}
